/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  const currentYear = new Date().getFullYear();

  return (
    <Segment role="contentinfo" padded id="footer">
      <div className="footerTop">

        <div className='logoWhiteDiv'>
          <img src='../white-logo.png' alt='Logo White' className='logoWhite' />
        </div>

        <div>
          <List className="footerList">
            <div role="listitem" className="item">
              <p className="item">
                <FormattedMessage
                  id="Footer-Name"
                  defaultMessage="Name"
                />
              </p>
            </div>
            <div role="listitem" className="item">
              <p className="item">
                <FormattedMessage
                  id='Footer-Strasse-Nummer'
                  defaultMessage="Teststrasse, 12"
                />
              </p>
            </div>
            <div role="listitem" className="item">
              <p className="item">
                <FormattedMessage
                  id='Footer-Plz-Ort'
                  defaultMessage="3550, Langnau i.E."
                />
              </p>
            </div>
          </List>
        </div>
        
        <div>
          <List className="footerList">
            <div role="listitem" className="item">
              <i className="ri-phone-line"></i>
              <a className="item" href="tel:012 345 67 89">
                <FormattedMessage
                  id='Footer-Telefon'
                  defaultMessage="012 345 67 89"
                />
              </a>
            </div>
            <div role="listitem" className="item">
              <i className="ri-mail-line"></i>
              <a className="item" href="mailto:test.mail@test.ch">
                <FormattedMessage
                  id='Footer-Email'
                  defaultMessage="test.test@gmail.com"
                />
              </a>
            </div>
          </List>
        </div>
      </div>
      <hr/>
      <div className='footerBottom'>
        <div>
          <List className="footerList">
            <div role="listitem" className="item">
              <a className="item" href="./impressum">
                <FormattedMessage
                  id='Footer-Imprint'
                  defaultMessage="Impressum"
                />
              </a>
            </div>
            <div role="listitem" className="item">
              <a className="item" href="./datenschutzerklaerung">
                <FormattedMessage
                  id='Footer-privacy'
                  defaultMessage="Datenschutzerklärung"
                />
              </a>
            </div>
            <div role="listitem" className="item">
              <i className="ri-copyright-line"></i>
              {currentYear}&nbsp;
              <FormattedMessage
                id='Footer-Copyright'
                defaultMessage="Herrmann AG"
              />
            </div>
          </List>
        </div>
      </div>
    </Segment>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);